import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useIsMobile } from '../utils/responsive';
import { getFarmPath } from '../utils/utils';

export interface NavigateToFarmFunction {
  (farmId: string, options?: NavigateOptions, openInNewTab?: boolean): void;
}

const useNavigateToFarm = (): NavigateToFarmFunction => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (farmId, options, openInNewTab = false) => {
    const farmPath = getFarmPath(farmId, isMobile ? 'map' : 'fields');
    if (openInNewTab) {
      window.open(`${window.location.origin}${farmPath}`, '_blank');
    } else {
      navigate(farmPath, options);
    }
  };
};

export default useNavigateToFarm;
